<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        width="90%"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="2vh"
        :title="showTitle()"
        custom-class="update-employee-dialog sk-dialog"
    >
      <el-form
          label-width="140px"
          :model="formAllTabEmployee"
          label-position="left"
          :rules="rules"
          ref="formAllTabEmployee"
          class="update-employee-form"
      >
        <div class="update-employee-content">
          <div class="employee-panel">
            <el-tabs class="update-employee-tabs" type="card" v-model="activeTabName">
          <el-tab-pane label="Thông tin" name="infoTab">
            <div class="common-info-tab">
              <el-row :gutter="24">
                <!-- Column 1: Profile Summary, status & QR -->
                <el-col :span="6">
                  <div class="profile-sidebar-card">
                    <!-- Avatar Area -->
                    <div class="profile-avatar-wrap">
                      <el-image
                          v-if="(formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView && showPictureQrInitial) || imageUrlPreview"
                          class="profile-avatar"
                          :src="imageUrlPreview ? imageUrlPreview : formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView"
                          fit="cover"
                      ></el-image>
                      
                      <!-- Hidden upload trigger -->
                      <el-upload
                          :disabled="showDetail"
                          :show-file-list="false"
                          :on-change="toggleUpload"
                          :on-remove="handleRemove"
                          :auto-upload="false"
                          style="display: none;"
                          ref="upload"
                          action=""
                      >
                      </el-upload>
                      
                      <!-- Click-to-add Area if empty -->
                      <div 
                          v-if="!((formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView && showPictureQrInitial) || imageUrlPreview)"
                          class="avatar-trigger-area"
                          @click="triggerAvatarUpload"
                      >
                        <i class="el-icon-plus"></i>
                        <span>Thêm ảnh đại diện</span>
                      </div>
                      
                      <!-- Hover edit/delete overlay if image exists -->
                      <div 
                          v-else-if="!showDetail"
                          class="avatar-actions-overlay"
                      >
                        <button type="button" class="avatar-action-btn edit-btn" @click="triggerAvatarUpload" title="Thay đổi ảnh">
                          <i class="el-icon-edit-outline"></i>
                        </button>
                        <button type="button" class="avatar-action-btn delete-btn" @click="handleRemove" title="Xóa ảnh">
                          <i class="el-icon-delete"></i>
                        </button>
                      </div>
                    </div>

                    <!-- QR Bank Card Area -->
                    <div class="qr-bank-section">
                      <div class="section-divider">Ảnh QR ngân hàng</div>
                      <div class="qr-container-wrap">
                        <el-image
                            v-if="(formAllTabEmployee.updateEmployeeMainInfoRequest.qrCodeWeb && showPictureQrInitial) || qrUrlPreview"
                            class="qr-bank-image"
                            :src="qrUrlPreview ? qrUrlPreview : formAllTabEmployee.updateEmployeeMainInfoRequest.qrCodeWeb"
                            fit="contain"
                        ></el-image>
                        
                        <!-- Hidden upload trigger for QR -->
                        <el-upload
                            :disabled="showDetail"
                            :show-file-list="false"
                            :on-change="toggleUploadQr"
                            :on-remove="handleRemoveQr"
                            :auto-upload="false"
                            style="display: none;"
                            ref="uploadQrBank"
                            action=""
                        >
                        </el-upload>

                        <!-- Click-to-add Area if empty -->
                        <div 
                            v-if="!((formAllTabEmployee.updateEmployeeMainInfoRequest.qrCodeWeb && showPictureQrInitial) || qrUrlPreview)"
                            class="qr-trigger-area"
                            @click="triggerQrUpload"
                        >
                          <i class="el-icon-plus"></i>
                          <span>Thêm QR</span>
                        </div>
                        
                        <!-- Hover edit/delete overlay if QR exists -->
                        <div 
                            v-else-if="!showDetail"
                            class="qr-actions-overlay"
                        >
                          <button type="button" class="avatar-action-btn edit-btn" @click="triggerQrUpload" title="Thay đổi QR">
                            <i class="el-icon-edit-outline"></i>
                          </button>
                          <button type="button" class="avatar-action-btn delete-btn" @click="handleRemoveQr" title="Xóa QR">
                            <i class="el-icon-delete"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Employee Code Badge -->
                    <div class="profile-code-section">
                      <span class="profile-code-label">Mã nhân sự</span>
                      <div class="profile-code-value">{{ formAllTabEmployee.updateEmployeeMainInfoRequest.code }}</div>
                    </div>

                    <!-- Status Area -->
                    <div class="profile-status-section">
                      <div class="section-divider">Trạng thái làm việc</div>
                      <el-radio-group
                          :disabled="showDetail"
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus"
                          class="status-radio-group"
                      >
                        <el-radio-button label="Đang làm">Đang làm</el-radio-button>
                        <el-radio-button label="Tạm nghỉ">Tạm nghỉ</el-radio-button>
                        <el-radio-button label="Nghỉ làm">Nghỉ làm</el-radio-button>
                      </el-radio-group>
                      
                      <!-- Status datepickers styled beautifully -->
                      <transition name="el-zoom-in-top">
                        <div class="status-date-wrap" v-if="formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus == 'Tạm nghỉ' || formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus == 'Nghỉ làm'">
                          <el-form-item
                              prop="updateEmployeeMainInfoRequest.dateRetain"
                              v-if="formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus == 'Tạm nghỉ'"
                              label="Ngày tạm nghỉ"
                          >
                            <el-date-picker
                                style="width: 100%"
                                type="date"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd"
                                placeholder="Chọn ngày"
                                v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.dateRetain"
                            ></el-date-picker>
                          </el-form-item>

                          <el-form-item
                              prop="updateEmployeeMainInfoRequest.dateLeave"
                              v-if="formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus == 'Nghỉ làm'"
                              label="Ngày nghỉ làm"
                          >
                            <el-date-picker
                                style="width: 100%"
                                v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.dateLeave"
                                type="date"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd"
                                placeholder="Chọn ngày"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </transition>
                    </div>
                  </div>
                </el-col>

                <!-- Column 2: Personal Information Grid -->
                <el-col :span="9">
                  <div class="info-section-card">
                    <div class="card-inner-title"><i class="el-icon-user"></i> Thông tin nhân sự</div>
                    
                    <el-form-item label="Họ tên" prop="updateEmployeeMainInfoRequest.fullName">
                      <el-input
                          :disabled="showDetail"
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.fullName"
                      ></el-input>
                    </el-form-item>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Số điện thoại" prop="updateEmployeeMainInfoRequest.phone">
                          <el-input
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.phone"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item prop="updateEmployeeMainInfoRequest.gender" label="Giới tính">
                          <el-radio-group
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.gender"
                              class="gender-radio-group"
                          >
                            <el-radio-button label="Nam">Nam</el-radio-button>
                            <el-radio-button label="Nữ">Nữ</el-radio-button>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày sinh" prop="updateEmployeeMainInfoRequest.birthday">
                          <el-date-picker
                              :disabled="showDetail"
                              :clearable="false"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.birthday"
                              format="dd-MM-yyyy"
                              :picker-options="pickerOptions"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="Chọn ngày sinh"
                              style="width: 100%"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Dân tộc" prop="updateEmployeeMainInfoRequest.ethnic">
                          <el-input
                              :disabled="showDetail"
                              clearable
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.ethnic"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-form-item label="Email" prop="updateEmployeeMainInfoRequest.email">
                      <el-input
                          :disabled="showDetail"
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.email"
                      ></el-input>
                    </el-form-item>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item prop="updateEmployeeMainInfoRequest.cmnd">
                          <span slot="label">
                            Số định danh
                            <el-tooltip class="item" effect="dark" content="Số định danh của nhân sự" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </span>
                          <el-input
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.cmnd"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Ngày cấp" prop="updateEmployeeMainInfoRequest.cmndDate">
                          <el-date-picker
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.cmndDate"
                              style="width: 100%"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="Chọn ngày cấp"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <div class="section-divider" style="margin: 16px 0 12px;">Tài khoản nhận lương</div>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngân hàng">
                          <el-input
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.nameBank"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Số tài khoản">
                          <el-input
                              type="number"
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.bankAccountNumber"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>

                <!-- Column 3: Work & Other Details -->
                <el-col :span="9">
                  <div class="info-section-card parent-card">
                    <div class="card-inner-title"><i class="el-icon-suitcase-1"></i> Thông tin công việc & Hôn nhân</div>
                    
                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày vào" prop="updateEmployeeMainInfoRequest.startDate">
                          <el-date-picker
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.startDate"
                              type="date"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              style="width: 100%"
                              placeholder="Chọn ngày vào"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Ngày ký hợp đồng" prop="updateEmployeeMainInfoRequest.contractDate">
                          <el-date-picker
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.contractDate"
                              type="date"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              style="width: 100%"
                              placeholder="Chọn ngày"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày hết hạn" prop="updateEmployeeMainInfoRequest.endDate">
                          <el-date-picker
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.endDate"
                              type="date"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              style="width: 100%"
                              placeholder="Ngày hết hạn"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Trình độ" prop="updateEmployeeMainInfoRequest.educationLevel">
                          <el-input
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.educationLevel"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Đối tượng" prop="updateEmployeeMainInfoRequest.idAccountTypeList">
                          <el-select
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.idAccountTypeList"
                              multiple
                              placeholder="Chọn đối tượng"
                              clearable
                              style="width: 100%"
                              filterable
                          >
                            <el-option
                                v-for="item in accountTypeList"
                                :key="item.id"
                                :value="item.id"
                                :label="item.name"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Hôn nhân" prop="updateEmployeeMainInfoRequest.marriedStatus">
                          <el-select
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.marriedStatus"
                              filterable
                              clearable
                              style="width: 100%"
                          >
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="24">
                        <el-form-item label="Số con" prop="updateEmployeeMainInfoRequest.numberChildren">
                          <el-input
                              :disabled="showDetail"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.numberChildren"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-form-item label="Địa chỉ thường trú" prop="updateEmployeeMainInfoRequest.permanentAddress">
                      <el-input
                          :disabled="showDetail"
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.permanentAddress"
                      ></el-input>
                    </el-form-item>
                    
                    <el-form-item label="Chỗ ở hiện tại" prop="updateEmployeeMainInfoRequest.address">
                      <el-input
                          :disabled="showDetail"
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.address"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="Ghi chú" prop="updateEmployeeMainInfoRequest.note">
                      <el-input
                          :disabled="showDetail"
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.note"
                          type="textarea"
                          :rows="1"
                          style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>

          <!-- tab phong ban -->
          <el-tab-pane label="Phòng ban">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="formAllTabEmployee.tabDepartmentInEmployee"
                  :header-cell-style="tableHeaderColor"
                  :max-height="$tableMaxHeight"
                  border
              >
                <el-table-column
                    type="index"
                    label="STT"
                    width="50"
                    align="center"
                ></el-table-column>
                <el-table-column
                    prop="departmentName"
                    label="Tên phòng ban"
                    align="center"
                ></el-table-column>
                <el-table-column label="Chọn phòng ban" align="center">
                  <template v-slot:default="scope">
                    <el-checkbox :disabled="showDetail" v-model="scope.row.checkDepartment"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="Chức vụ" align="center">
                  <template v-slot:default="scope">
                    <el-input
                        :disabled="showDetail"
                        v-model="scope.row.position"
                        placeholder="Điền chức vụ"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- tab chuyen mon -->
          <el-tab-pane label="Chuyên môn">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="formAllTabEmployee.tabProfessionalInEmployee"
                  :header-cell-style="tableHeaderColor"
                  :max-height="$tableMaxHeight"
                  border
              >
                <el-table-column
                    type="index"
                    label="STT"
                    width="50"
                    align="center"
                ></el-table-column>
                <el-table-column
                    prop="className"
                    label="Tên Lớp"
                    align="center"
                ></el-table-column>
                <el-table-column label="Lớp dạy" align="center">
                  <template v-slot:default="scope">
                    <el-checkbox
                        :disabled="showDetail"
                        @change="selectionMultiProfessional(scope.$index, scope.row)"
                        v-model="scope.row.checkIsClass"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="Chủ nhiệm" align="center">
                  <template v-slot:default="scope">
                    <el-checkbox
                        :disabled="showDetail"
                        v-model="scope.row.isMaster"
                        v-if="scope.row.checkIsClass"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="Chọn môn" align="center">
                  <template v-slot:default="scope">
                    <el-select
                        :disabled="showDetail"
                        v-if="scope.row.checkIsClass"
                        v-model="scope.row.listIdSubject"
                        placeholder="Chọn môn học"
                        multiple
                    >
                      <el-option
                          v-for="item in scope.row.subjectResponseList"
                          :key="item.id"
                          :label="item.subjectName"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                    <el-select
                        v-else
                        disabled
                        v-model="scope.row.listIdSubject"
                        placeholder="Chọn môn học"
                        multiple
                    >
                      <el-option
                          v-for="item in scope.row.subjectResponseList"
                          :key="item.id"
                          :label="item.subjectName"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
              <br/>
            </div>
          </el-tab-pane>
          <el-tab-pane label="App Teacher">
            <!-- table 1 -->
            <el-table
                class="table-icon-1"
                border
                :data="teacherIconAppUpdate.teacherIconUpdate1"
                highlight-current-row
                :header-cell-style="tableHeaderColor"
                :max-height="$tableMaxHeight"
            >
              <el-table-column type="index"></el-table-column>
              <el-table-column prop="iconName" label="Chức năng"></el-table-column>
              <el-table-column label="Hiển thị" align="center">
                <template v-slot:default="scope">
                  <el-checkbox :disabled="showDetail" v-model="scope.row.statusShow"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Mở khóa" align="center">
                <template v-slot:default="scope">
                  <el-checkbox
                      :disabled="showDetail"
                      v-if="scope.row.rootLockStatus"
                      v-model="scope.row.status"
                  ></el-checkbox>
                  <el-checkbox v-else disabled></el-checkbox>
                </template>
              </el-table-column>
            </el-table>

            <!-- table 2 -->
            <el-table
                class="table-icon-2"
                border
                :data="teacherIconAppUpdate.teacherIconUpdate2"
                highlight-current-row
                :header-cell-style="tableHeaderColor"
                :max-height="$tableMaxHeight"
            >
              <el-table-column type="index"></el-table-column>
              <el-table-column prop="iconName" label="Chức năng"></el-table-column>
              <el-table-column label="Hiển thị" align="center">
                <template v-slot:default="scope">
                  <el-checkbox :disabled="showDetail" v-model="scope.row.statusShow"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Mở khóa" align="center">
                <template v-slot:default="scope">
                  <el-checkbox
                      :disabled="showDetail"
                      v-if="scope.row.rootLockStatus"
                      v-model="scope.row.status"
                  ></el-checkbox>
                  <el-checkbox v-else disabled></el-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="Cấu hình Cam" name="commonConfig">
            <el-row>
              <el-col :span="5" :offset="7">
                <el-checkbox
                    :disabled="showDetail"
                    v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.oneCamStatus"
                ></el-checkbox>
                <span style="margin-left: 10px">Cho phép xem Camera ở OneCamPlus không?</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :offset="7">
                <el-table
                    style="width: 700px; margin-top: 10px"
                    ref="multipleTable"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255,255,255, 0)"
                    :data="employeeCamList"
                    highlight-current-row
                    :header-cell-style="tableHeaderColor"
                    border
                >
                  <el-table-column
                      type="index"
                      label="STT"
                      width="50"
                      align="center"
                  ></el-table-column>
                  <el-table-column prop="cameraName" label="Tên cam"></el-table-column>
                  <el-table-column prop="active" label="Trạng thái" width="100px" align="center">
                    <template v-slot:default="scope">
                      <el-checkbox
                          :disabled="scope.row.existClass || showDetail"
                          v-model="scope.row.active"
                          style="margin-left: 10px"
                      ></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="Tác vụ"
                      width="120"
                      align="center"
                  >
                    <template v-slot:default="scope">
                      <el-button
                          :disabled="scope.row.existClass || !scope.row.active || showDetail"
                          size="mini"
                          type="success"
                          @click="handleSettingCame(scope.row.idCamera, scope.row.cameraName)"
                      >Thiết lập
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane>

          <!--      Quản lý khuôn mặt-->
          <el-tab-pane label="Quản lý nhận diện AI" name="faceManagement" v-if="!showDetail &&  checkPermission(['recognition-manager'])">
            <el-row>
              <el-col>
                <el-form ref="faceManagement" :model="kidFaceManagement"
                         class="ai-management-form"
                         label-position="top"
                         v-loading="loadingRecognition"
                         element-loading-text="Loading..."
                         element-loading-spinner="el-icon-loading"
                         element-loading-background="rgba(0, 0, 0, 0.8)"
                         :rules="rulesFaceManagement">
                  <div class="ai-layout">
                    <div class="ai-panel ai-panel-intro">
                      <div class="ai-panel-title">Thiết lập nhận diện AI</div>
                      <div class="ai-panel-subtitle">Cập nhật khuôn mặt, thiết bị, thẻ và vân tay cho nhân sự.</div>
                    </div>

                    <el-row :gutter="20" class="ai-upper-layout">
                      <!-- Left Column: Face Scan -->
                      <el-col :span="8" v-if="checkPermission(['recognition-manager-face-employee'])">
                        <div class="ai-panel ai-avatar-panel">
                          <div class="ai-panel-inner-title required">Ảnh chân dung nhận diện</div>
                          <el-form-item prop="urlWebFace" class="ai-face-form-item">
                            <div class="ai-avatar-scanner">
                              <div class="ai-avatar-scanner-view">
                                <div class="scanner-corner top-left"></div>
                                <div class="scanner-corner top-right"></div>
                                <div class="scanner-corner bottom-left"></div>
                                <div class="scanner-corner bottom-right"></div>
                                <div class="scanner-line"></div>
                                <div class="ai-avatar-box">
                                  <!-- Show existing server image -->
                                  <el-image
                                      v-if="kidFaceManagement.urlWebFace && !checkCreateRecognition && !facePreviewUrl"
                                      class="ai-avatar-preview"
                                      :src="kidFaceManagement.urlWebFace"
                                      fit="cover"
                                  ></el-image>
                                  <!-- Show newly uploaded image preview -->
                                  <el-image
                                      v-else-if="facePreviewUrl"
                                      class="ai-avatar-preview"
                                      :src="facePreviewUrl"
                                      fit="cover"
                                  ></el-image>
                                  <!-- Empty state -->
                                  <div v-else class="ai-avatar-empty">
                                    <i class="el-icon-camera"></i>
                                    <span>Chưa có ảnh</span>
                                  </div>
                                </div>
                              </div>
                              <!-- Hidden upload -->
                              <el-upload
                                  ref="uploadFace"
                                  class="ai-upload-face-hidden"
                                  :show-file-list="false"
                                  :on-change="handleChangeUploadFace"
                                  :auto-upload="false"
                                  accept="image/jpeg,image/png"
                                  action=""
                              >
                              </el-upload>
                              <!-- Action buttons -->
                              <div class="ai-face-actions">
                                <el-button
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-upload2"
                                    @click="triggerFaceUpload"
                                >{{ hasFaceImage ? 'Sửa ảnh' : 'Thêm ảnh' }}</el-button>
                                <el-button
                                    size="mini"
                                    type="danger"
                                    icon="el-icon-delete"
                                    :disabled="!hasFaceImage"
                                    @click="handleDeleteFace"
                                >Xóa</el-button>
                                <el-button
                                    size="mini"
                                    icon="el-icon-zoom-in"
                                    :disabled="!hasFaceImage"
                                    @click="handlePreviewFace"
                                >Xem</el-button>
                              </div>
                              <div class="ai-avatar-note">
                                <i class="el-icon-info"></i>
                                <span>Ảnh chân dung rõ nét sẽ giúp thiết bị AI nhận diện nhân sự ổn định hơn.</span>
                              </div>
                            </div>
                          </el-form-item>
                          <!-- Face preview dialog -->
                          <el-dialog
                              :visible.sync="facePreviewDialogVisible"
                              title="Xem ảnh chân dung"
                              width="500px"
                              append-to-body
                              custom-class="face-preview-dialog"
                          >
                            <div class="face-preview-wrap">
                              <img :src="facePreviewDialogUrl" alt="Ảnh chân dung" />
                            </div>
                          </el-dialog>
                        </div>
                      </el-col>

                      <!-- Right Column: Form Settings -->
                      <el-col :span="checkPermission(['recognition-manager-face-employee']) ? 16 : 24">
                        <div class="ai-panel ai-form-panel">
                          <div class="ai-panel-inner-title">Cấu hình thông tin</div>

                          <el-row :gutter="20">
                            <el-col :span="24">
                              <el-form-item label="Thiết bị hiện tại để truy vấn" prop="idDevice">
                                <el-select
                                    class="ai-control"
                                    v-model="kidFaceManagement.idDevice"
                                    placeholder="Chọn thiết bị truy vấn"
                                    @change="handleCurrentDeviceChange"
                                    value-key="id">
                                  <el-option
                                      v-for="item in listIdDevice"
                                      :key="item.id"
                                      :value="item.id"
                                      :label="item.id + ' - ' + item.nameDevice"
                                  >
                                    <span>{{ item.id }}</span> - <span>{{ item.nameDevice }}</span>
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                          </el-row>

                          <el-row :gutter="20">
                            <el-col :span="12">
                              <el-form-item prop="name" label="Nhập họ tên">
                                <el-input
                                    placeholder="Nhập họ và tên"
                                    class="ai-control"
                                    clearable
                                    v-model="kidFaceManagement.name"
                                ></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="Chọn thiết bị nhận diện" prop="idDeviceList">
                                <el-select
                                    class="ai-control"
                                    collapse-tags
                                    :multiple="true"
                                    v-model="kidFaceManagement.idDeviceList"
                                    placeholder="Chọn thiết bị nhận diện"
                                    @change="handleDeviceListChange"
                                    value-key="id">
                                  <el-option
                                      v-for="item in listIdDevice"
                                      :key="item.id"
                                      :value="item.id"
                                      :label="item.id + ' - ' + item.nameDevice"
                                  >
                                    <span>{{ item.id }}</span> - <span>{{ item.nameDevice }}</span>
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                          </el-row>

                          <el-row :gutter="20">
                            <el-col :span="12">
                              <el-form-item prop="startTime" label="Chọn ngày bắt đầu">
                                <el-date-picker
                                    class="ai-control"
                                    v-model="kidFaceManagement.startTime"
                                    format="dd-MM-yyyy"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="Chọn ngày bắt đầu"
                                    @change="handleStartDateChange(kidFaceManagement.startTime)"
                                ></el-date-picker>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item prop="endTime" label="Chọn ngày kết thúc">
                                <el-date-picker
                                    class="ai-control"
                                    v-model="kidFaceManagement.endTime"
                                    format="dd-MM-yyyy"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="Chọn ngày kết thúc"
                                    :picker-options="endDateOptions"
                                ></el-date-picker>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </div>
                      </el-col>
                    </el-row>

                    <!--                  Thêm thẻ-->
                    <el-row class="ai-section ai-panel" v-if="checkPermission(['recognition-manager-card-employee'])">
                      <el-col :span="24">
                        <div class="ai-counter-title">
                          <span class="ai-counter-label">Thẻ vật lý</span>
                          <span class="ai-counter-value">{{ numberCard }}/{{ kidFaceManagement.cardNumber }}</span>
                        </div>

                        <el-row :gutter="20">
                          <el-col v-for="(card, index) in cardList" :key="index" :span="6" class="ai-item-col">
                            <div class="ai-card-item">
                              <div class="ai-card-content">
                                <div class="ai-card-text">
                                  <strong>{{ card.cardName }}</strong>
                                  <div>ID: {{ card.cardNo }}</div>
                                  <div>No: {{ card.cardCodeShow }}</div>
                                </div>
                                <img src="@/assets/card.png" class="ai-card-icon"/>
                                <div class="card-actions-overlay">
                                  <i class="el-icon-edit action-btn edit" @click="handleEditCard(index)"></i>
                                  <i class="el-icon-delete action-btn delete"
                                     v-if="checkPermission(['recognition-manager-delete-card-employee'])"
                                     @click="handleDeleteCard(index)"></i>
                                </div>
                              </div>
                            </div>
                          </el-col>

                          <el-col :span="6" class="ai-item-col">
                            <div class="ai-add-item" @click="handledOpenAddCardDialog">
                              <i class="el-icon-plus"></i>
                              <span>Thêm thẻ mới</span>
                            </div>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>

                    <!--                      Thêm vân tay-->
                    <el-row class="ai-section ai-finger-section ai-panel" v-if="checkPermission(['recognition-manager-finger-employee'])">
                      <el-col :span="24">
                        <div class="ai-counter-title">
                          <span class="ai-counter-label">Dữ liệu vân tay</span>
                          <span class="ai-counter-value">{{ numberFinger }}/{{ kidFaceManagement.fingerNumber }}</span>
                        </div>
                        <el-row :gutter="20">
                          <el-col v-for="(fp, index) in listFinger" :key="index" :span="6" class="ai-item-col">
                            <div class="ai-finger-item">
                              <div class="ai-card-content">
                                <div class="ai-card-text">
                                  <strong>{{ fp.fingerName }}</strong>
                                  <div>ID Vân tay: #{{ fp.fingerNo }}</div>
                                </div>
                                <img src="@/assets/finger.png" class="ai-card-icon"/>
                                <div class="card-actions-overlay">
                                  <i class="el-icon-edit action-btn edit" @click="handleEditFinger(fp)"></i>
                                  <i class="el-icon-delete action-btn delete" @click="handleDeleteFinger(fp)"></i>
                                </div>
                              </div>
                            </div>
                          </el-col>
                          <el-col :span="6" class="ai-item-col">
                            <div class="ai-add-item" @click="handledOpenAddFingerDialog">
                              <i class="el-icon-plus"></i>
                              <span>Thêm vân tay mới</span>
                            </div>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>

                    <div class="ai-actions">
                      <el-button
                          class="ai-btn-delete"
                          v-if="!this.checkCreateRecognition"
                          type="danger"
                          size="medium"
                          :loading="loadingButtonRecognition"
                          mini
                          @click="deleteDataRecognition"
                      >
                        <i class="el-icon-circle-check"/>
                        <span>Xóa dữ liệu nhận diện</span>
                      </el-button>
                      <el-button
                          class="ai-btn-submit"
                          :disabled="this.checkRecognition"
                          type="success"
                          size="medium"
                          :loading="loadingButtonRecognition"
                          mini
                          @click="submitFormFaceManagement('faceManagement')"
                      >
                        <i class="el-icon-circle-check"/>
                        <span>{{ titleButtonRecognition }}</span>
                      </el-button>
                    </div>
                  </div>
                </el-form>
              </el-col>
            </el-row>
          </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-form>
      <div class="tab-infor-button update-employee-footer" v-if="showButtonClick">
        <el-button
            class="btn-cancel"
            type="danger"
            size="medium"
            @click="closeDialogByButton('formAllTabEmployee')"
        >
          <i class="el-icon-circle-close"/>
          <span>Đóng</span>
        </el-button>
        <el-button
            class="btn-save"
            :disabled="activeTabName === 'faceManagement'"
            type="success"
            size="medium"
            :loading="loadingButton"
            mini
            @click="submitForm('formAllTabEmployee')"
        >
          <i class="el-icon-circle-check"/>
          <span>Lưu</span>
        </el-button>
      </div>
    </el-dialog>
    <div>
      <el-dialog
          title="Lưu ý"
          :visible.sync="showWarning"
          width="30%"
          :show-close="true"
          center
      >
        <div style="display: flex; align-items: center;">
          <!-- Icon cảnh báo -->
          <i class="el-icon-warning" style="font-size: 60px; color: #e6a23c; margin-right: 15px;"></i>

          <!-- Nội dung -->
          <div>
            <p style="font-size: 16px; margin: 0;">{{ contentDevice }}</p>
          </div>
        </div>
      </el-dialog>
      <el-dialog
          title="Thêm người dùng cho thẻ"
          :visible.sync="dialogVisibleCard"
          :close-on-click-modal="false"
          width="500px"
      >
        <div>
          <span>Tên người dùng</span>
        </div>
        <div>
          <el-input placeholder="Nhập tên người dùng" v-model="cardName"></el-input>
        </div>
        <div style="margin-top: 20px">
          <span>No</span>
        </div>
        <div>
          <el-input placeholder="Nhập mã thẻ" v-model="cardCode"></el-input>
        </div>
        <div  class="custom_button">
          <el-button @click="getInformationNumberCard" type="success" size="medium">Tiếp tục</el-button>
          <el-button @click="handleCloseCard" type="danger" size="medium">Hủy</el-button>
        </div>
      </el-dialog>
      <el-dialog
          title="Sửa người dùng cho thẻ"
          :visible.sync="dialogVisibleEditCard"
          :close-on-click-modal="false"
          width="500px"
      >
        <div>
          <span>Tên người dùng</span>
        </div>
        <div>
          <el-input placeholder="Nhập tên người dùng" v-model="cardNameEdit"></el-input>
        </div>
        <div style="margin-top: 20px">
          <span>No</span>
        </div>
        <div>
          <el-input placeholder="Nhập mã thẻ" v-model="cardCodeEdit" type="number"></el-input>
        </div>
        <div  class="custom_button">
          <el-button @click="saveInformationNumberCard(card)" type="success" size="medium">Lưu</el-button>
          <el-button @click="handleCloseEditCard" type="danger" size="medium">Hủy</el-button>
        </div>
      </el-dialog>
      <el-dialog
          title="Thêm tên người dùng cho dấu vân tay"
          :visible.sync="dialogVisibleFinger"
          :close-on-click-modal="false"
          width="500px"
      >
        <el-input placeholder="Nhập tên người dùng" v-model="fingerName"></el-input>
        <div  class="custom_button">
          <el-button @click="getInformationFinger" type="success" size="medium">Tiếp tục</el-button>
          <el-button @click="handleCloseFinger" type="danger" size="medium">Hủy</el-button>
        </div>
      </el-dialog>
      <el-dialog
          title="Sửa tên người dùng cho dấu vân tay"
          :visible.sync="dialogVisibleEditFinger"
          :close-on-click-modal="false"
          width="500px"
      >
        <el-input placeholder="Nhập tên người dùng" v-model="fingerNameEdit"></el-input>
        <div  class="custom_button">
          <el-button @click="saveInformationEditFinger(finger)" type="success" size="medium">Tiếp tục</el-button>
          <el-button @click="handleCloseEditFinger" type="danger" size="medium">Hủy</el-button>
        </div>
      </el-dialog>
    </div>
    <CamSettingEmployeeDialog
        :showSettingCamera="showSettingCamera"
        :idEmployee="idEmployee"
        :idCamera="idCamera"
        :nameCamera="nameCamera"
        @close="handleCloseSettingCameraDialog"
    />
  </div>
</template>

<script>
import EmployeeDataService from "@/services/EmployeeService/EmployeeDataService";
import employeeDataService from "@/services/EmployeeService/EmployeeDataService";
import {mapActions} from "vuex";
import CamSettingEmployeeDialog from "@/views/employee/CamSettingEmployeeDialog.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import checkPermission from "@/utils/permission";

export default {
  components: {CamSettingEmployeeDialog},
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      showSettingCamera: false,
      idCamera: 0,
      idEmployee: 0,
      nameCamera: "",
      employeeCamList: [],
      showDetail: false,
      showPictureQrInitial: true,
      fileList: [],
      fileListQr: [],
      dialogImageUrl: "",
      imageUrlPreview: "",
      qrUrlPreview: "",
      dialogVisible1: false,
      fileAvatar: "",
      fileQrBank: null,
      showUpload: true,
      showUploadQr: true,
      src: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      avatar: {},
      isMasterAccountType: true,
      idEmployeeEdit: "",
      accountTypeList: [],
      showButtonClick: true,
      value: "",
      radiogender: "",
      options: [
        {
          value: "Độc thân",
          label: "Độc thân",
        },
        {
          value: "Đã kết hôn",
          label: "Đã kết hôn",
        },
      ],
      teacherIconAppUpdate: {
        teacherIconUpdate1: [],
        teacherIconUpdate2: [],
      },
      plusIconAppUpdate: {
        plusIconUpdate1: [],
        plusIconUpdate2: [],
      },
      notifyPlusIconAppUpdate: {
        notifyPlusIconUpdate1: [],
        notifyPlusIconUpdate2: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      loadingButton: false,
      formAllTabEmployee: {
        updateEmployeeMainInfoRequest: {
          id: "",
          idAccountTypeList: [],
          fullName: "",
          birthday: "",
          address: "",
          gender: "",
          email: "",
          phone: "",
          cmnd: "",
          cmndDate: "",
          permanentAddress: "",
          marriedStatus: "",
          numberChildren: "",
          educationLevel: "",
          startDate: "",
          contractDate: "",
          endDate: "",
          employeeStatus: "",
          note: "",
          dateLeave: "",
          dateRetain: "",
          avatar: "",
          avatarView: "",
          bankAccountNumber: "",
          nameBank: "",
          imgBank: "",
        },
        tabDepartmentInEmployee: [],
        tabDepartmentRequestList: [],
        tabProfessionalInEmployee: [],
        tabProfessionalRequestList: [],
        notifyAppIconPlusRequestList: [],
        idSchool: "",
      },
      listIdDevice: [],
      idDeviceList: [],
      checkCreateRecognition: true,
      titleButtonRecognition: "Lưu dữ liệu",
      loadingButtonRecognition: false,
      cardList: [],
      cardListDataBase: [],
      listFinger: [],
      listFingerDB: [],
      cardIcon: require('@/assets/card.png'),
      showWarning: false,
      loadingRecognition: false,
      listCardDelete: [],
      listFingerDelete: [],
      contentDevice: "",
      checkRecognition: false,
      numberCard: 0,
      numberFinger:0,
      dialogVisibleCard: false,
      dialogVisibleFinger: false,
      cardName: "Nhân viên",
      fingerName: "Nhân viên",
      dialogVisibleEditCard: false,
      cardNameEdit: "",
      cardCodeEdit: "",
      card: {},
      dialogVisibleEditFinger: false,
      fingerNameEdit: "",
      finger: {},
      listFingerUpdate: [],
      listCardUpdate: [],
      imageFaceUrl: "",
      listFileFace: [],
      showUploadFace: true,
      facePreviewUrl: "",
      facePreviewDialogVisible: false,
      facePreviewDialogUrl: "",
      cardCode: "",
      endDateOptions: {
        disabledDate: () => false, // Mặc định không chặn ngày nào
      },
      kidFaceManagement: {
        id: null,
        name: "",
        gender: "",
        startTime: "",
        endTime: "",
        urlWebFace: "",
        idDevice: null,
        idDeviceList: [],
        cardNumber: 0,
        fingerNumber: 0,
        idSchool: 0,
      },
      searchUserRequest: {
        idUser: 0,
        idDevice: 0,
        typeAccount: "teacher"
      },
      activeTabName: "infoTab",
      rulesFaceManagement: {
        name: [
          {
            required: true,
            message: "Họ tên không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        urlWebFace: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.checkPermission(['recognition-manager-face-employee']) && !this.hasFaceImage) {
                return callback(new Error("Ảnh không được để trống"));
              }
              callback();
            },
            trigger: ["change", "blur"],
          },
        ],
        idDevice: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const val = value || this.kidFaceManagement.idDevice || this.searchUserRequest.idDevice;
              if (!val || val === 0) {
                return callback(new Error("Thiết bị hiện tại không được để trống"));
              }
              callback();
            },
            trigger: ["change", "blur"],
          },
        ],
        idDeviceList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const list = (value && value.length > 0) ? value : (this.kidFaceManagement.idDeviceList && this.kidFaceManagement.idDeviceList.length > 0 ? this.kidFaceManagement.idDeviceList : this.idDeviceList);
              if (!list || !Array.isArray(list) || list.length === 0) {
                return callback(new Error("Thiết bị nhận diện không được để trống"));
              }
              callback();
            },
            trigger: ["change", "blur"],
          },
        ],
        startTime: [
          {
            required: true,
            message: "Ngày bắt đầu không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        endTime: [
          {
            required: true,
            message: "Ngày kết thúc không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      },
      rules: {
        updateEmployeeMainInfoRequest: {
          fullName: [
            {
              required: true,
              message: "Họ tên không được để trống",
              trigger: "blur",
            },
          ],
          phone: [
            {
              required: true,
              message: "Số điện thoại không được để trống",
              trigger: "change",
            },
            {
              min: 10,
              max: 10,
              message: "Số điện thoại bao gồm 10 số",
              trigger: "change",
            },
          ],
          gender: [
            {
              required: true,
              message: "Giới tính không được để trống",
              trigger: "blur",
            },
          ],
          startDate: [
            {
              required: true,
              message: "Ngày vào không được để trống",
              trigger: "blur",
            },
          ],
          birthday: [
            {
              required: true,
              message: "Giới tính không được để trống",
              trigger: "blur",
            },
          ],
          dateLeave: [
            {
              required: true,
              message: "Ngày nghỉ làm không được để trống",
              trigger: "change",
            },
          ],
          dateRetain: [
            {
              required: true,
              message: "Ngày tạm nghỉ không được để trống",
              trigger: "change",
            },
          ],
          email: [
            {
              type: "email",
              message: "Email không đúng định dạng",
              trigger: ["blur", "change"],
            },
          ],
        },
      },
    };
  },
  computed: {
    hasFaceImage() {
      return !!(this.facePreviewUrl || (this.kidFaceManagement.urlWebFace && !this.checkCreateRecognition));
    },
  },
  methods: {
    checkPermission,
    ...mapActions('employeeStore', ['fetchDataEmployeeList']),
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;border:1px solid #fff";
    },
    closeDialog() {
      this.activeTabName = "infoTab";
      this.$refs.upload.clearFiles();
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView = "";
      this.$refs["formAllTabEmployee"].resetFields();
      this.$emit("dialog-close");
      this.showPictureQrInitial = true;
      this.$parent.handleCurrentChangeAfter();
    },
    //click when click button
    closeDialogByButton(fromData) {
      this.activeTabName = "infoTab";
      this.$refs.upload.clearFiles();
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView = "";
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
      this.showUpload = true;
      this.showPictureQrInitial = true;
      this.handleRemoveQr();
      this.handleClearUserRecognition()
    },
    getEmployeeById(idEmployee) {
      this.idEmployeeEdit = idEmployee;
      EmployeeDataService.getEmployeeById(idEmployee)
          .then((response) => {
            console.log(response.data.data)
            this.formAllTabEmployee.updateEmployeeMainInfoRequest =
                response.data.data
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getEmployeeByIdAndIdSchool(idEmployee, idSchool) {
      this.formAllTabEmployee.idSchool = idSchool;
      this.idEmployeeEdit = idEmployee;
      EmployeeDataService.getEmployeeByIdAndIdSchool(idEmployee, idSchool)
          .then((response) => {
            this.formAllTabEmployee.updateEmployeeMainInfoRequest =
                response.data.data

          })
          .catch((err) => {
            console.log(err);
          });
    },
    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          this.submitSettingCamera();
          this.pushDataToCheckBoxDepartment();
          this.selectionMultiProfessional();
          let iconArrayTeacher1 = this.teacherIconAppUpdate.teacherIconUpdate1;
          let iconArrayTeacher2 = this.teacherIconAppUpdate.teacherIconUpdate2;
          this.formAllTabEmployee.appIconTeacherRequestList = iconArrayTeacher1.concat(iconArrayTeacher2);

          let iconArrayPlus1 = this.plusIconAppUpdate.plusIconUpdate1;
          let iconArrayPlus2 = this.plusIconAppUpdate.plusIconUpdate2;
          this.formAllTabEmployee.appIconPlusRequestList = iconArrayPlus1.concat(iconArrayPlus2);

          let iconNotifyArrayPlus1 = this.notifyPlusIconAppUpdate.notifyPlusIconUpdate1;
          let iconNotifyArrayPlus2 = this.notifyPlusIconAppUpdate.notifyPlusIconUpdate2;
          this.formAllTabEmployee.notifyAppIconPlusRequestList = iconNotifyArrayPlus1.concat(iconNotifyArrayPlus2);
          let formDatas = new FormData();

          formDatas.append(
              "idEmployee",
              this.formAllTabEmployee.updateEmployeeMainInfoRequest.id
          );
          formDatas.append(
              "fileName",
              this.formAllTabEmployee.updateEmployeeMainInfoRequest.avatar
          );
          if (this.fileAvatar != null && this.fileAvatar != "") {
            formDatas.append("multipartFile", this.fileAvatar);
            EmployeeDataService.uploadEditAvatar(formDatas)
                .then(() => {
                  if (this.fileQrBank) {
                    this.uploadEditQrBank();
                  }
                  this.updateEmployee(fromData);
                })
                .catch((err) => {
                  this.$message({
                    message: err.response.data.message,
                    type: "error",
                  });
                })
          } else {
            if (this.fileQrBank) {
              this.uploadEditQrBank();
            }
            this.updateEmployee(fromData);
            // this.$parent.handleCurrentChangeAfter();
          }
        } else {
          return false;
        }
        this.handleRemoveQr();
        this.handleClearUserRecognition();
        this.showUpload = true;
      });
    },
    /**
     * cập nhật nhân viên
     */
    updateEmployee(fromData) {
      EmployeeDataService.update(this.idEmployeeEdit, this.formAllTabEmployee)
          .then((response) => {
            this.$message({
              message: response.data.message,
              type: "success",
            });
            this.closeDialogByButton(fromData);
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingButton = false;
            }, 500);
          });
    },
    uploadEditAvatar(formData) {
      EmployeeDataService.uploadEditAvatar(formData)
          .then((res) => {
            console.log(res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
    },

    uploadEditQrBank() {
      const data = this.formAllTabEmployee.updateEmployeeMainInfoRequest;
      const formData = new FormData();

      formData.append("idEmployee", data.id);
      formData.append("multipartFile", this.fileQrBank);

      EmployeeDataService.uploadQrBank(formData);
    },
    clickNameInitial(data) {
      if (data == "fullName") {
        this.showDetail = true;
        this.showButtonClick = false;
        this.showTitle();
      } else if (data == "noFullName") {
        this.showDetail = false;
        this.showButtonClick = true;
        this.showTitle();
      }
    },
    showTitle() {
      if (this.showDetail === false) {
        return "Sửa nhân viên"
      } else return "Thông tin nhân viên"
    },
    getAllAccountType() {
      EmployeeDataService.getAccountType()
          .then((response) => {
            this.accountTypeList = response.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getTabDepartmentInEmployee() {
      EmployeeDataService.getTabDepartmentInEmployeeById(this.idEmployeeEdit)
          .then((response) => {
            this.formAllTabEmployee.tabDepartmentInEmployee = response.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getTabProfessionalInEmployee() {
      EmployeeDataService.getTabProfessionalInEmployeeById(this.idEmployeeEdit)
          .then((response) => {
            this.formAllTabEmployee.tabProfessionalInEmployee = response.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    tabTeacherIconMethod(id) {
      EmployeeDataService.findIconTeacherUpdate(id)
          .then((resp) => {
            this.teacherIconAppUpdate.teacherIconUpdate1 =
                resp.data.data.appIconTeacherResponseList1

            this.teacherIconAppUpdate.teacherIconUpdate2 =
                resp.data.data.appIconTeacherResponseList2;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    pushDataToCheckBoxDepartment() {
      let a = this.formAllTabEmployee.tabDepartmentInEmployee.filter(
          (item) => item.checkDepartment === true
      );
      this.formAllTabEmployee.tabDepartmentRequestList = a;
    },
    selectionMultiProfessional() {
      let a = this.formAllTabEmployee.tabProfessionalInEmployee.filter(
          (item) => item.checkIsClass === true
      );
      this.formAllTabEmployee.tabProfessionalRequestList = a;
    },
    triggerAvatarUpload() {
      if (this.showDetail) return;
      this.$refs.upload.$el.querySelector('.el-upload__input').click();
    },
    triggerQrUpload() {
      if (this.showDetail) return;
      this.$refs.uploadQrBank.$el.querySelector('.el-upload__input').click();
    },
    toggleUpload(file, fileList) {
      this.fileList = fileList;
      this.showPictureQrInitial = false;
      this.showUpload = !this.showUpload;
      this.fileAvatar = file.raw;
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.avatar = this.fileAvatar.name;
      this.imageUrlPreview = URL.createObjectURL(file.raw);
    },
    handleRemove(file) {
      setTimeout(() => {
        this.showPictureQrInitial = true;
        this.showUpload = !this.showUpload;
      }, 950);

      let index = this.fileList.indexOf(file);
      if (index >= 0) {
        this.fileList.splice(index, 1);
      }
      this.imageUrlPreview = "";
    },

    handleRemoveQr() {
      this.$refs.uploadQrBank.clearFiles();
      this.showUploadQr = true;
      this.showPictureQrInitial = true;
      this.fileQrBank = null;
      this.qrUrlPreview = "";
    },

    toggleUploadQr(file, fileList) {
      this.fileListQr = fileList;
      this.showPictureQrInitial = false;
      this.showUploadQr = false;
      this.fileQrBank = file.raw;
      this.qrUrlPreview = URL.createObjectURL(file.raw);
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible1 = true;
    },
    async getListCamera(id) {
      await employeeDataService.getListCamera(id, "teacher").then((response) => {
        this.employeeCamList = response.data
        this.idEmployee = id
      })
    },
    handleSettingCame(idCamera, nameCamera) {
      this.showSettingCamera = true
      this.nameCamera = nameCamera
      this.idCamera = idCamera
    },
    handleCloseSettingCameraDialog() {
      this.showSettingCamera = false
    },
    async submitSettingCamera() {
      this.cameraByUserRequestList = []
      for (let i = 0; i < this.employeeCamList.length; i++) {
        let cameraSetting = {
          idUserCam: this.idEmployee,
          idCamera: 0,
          nameCam: "",
          typeUser: "teacher",
          active: false
        }
        if (this.employeeCamList[i].existClass === false) {
          cameraSetting.idCamera = this.employeeCamList[i].idCamera
          cameraSetting.nameCam = this.employeeCamList[i].cameraName
          cameraSetting.active = this.employeeCamList[i].active
          this.cameraByUserRequestList.push(cameraSetting)
        }
      }
      let data = {
        cameraByUserRequestList: this.cameraByUserRequestList
      }
      await employeeDataService.saveSettingCameraPlus(data).then((res) => {
        console.log(res.data)
      }).catch((error) => {
        console.log(error)
      })
    },

    handleChangeUploadFace(file, fileList) {
      this.beforeFaceUpload(file, fileList);
      // Generate preview URL for the uploaded file
      if (file && file.raw) {
        this.facePreviewUrl = URL.createObjectURL(file.raw);
        this.$nextTick(() => {
          if (this.$refs.faceManagement) {
            this.$refs.faceManagement.validateField('urlWebFace');
          }
        });
      }
    },
    triggerFaceUpload() {
      this.$refs.uploadFace.$el.querySelector('.el-upload__input').click();
    },
    handleDeleteFace() {
      this.$refs.uploadFace.clearFiles();
      this.facePreviewUrl = "";
      this.showPictureInitial = true;
      this.listFileFace = [];
      this.showUploadFace = true;
      this.imageFaceUrl = null;
      this.kidFaceManagement.urlWebFace = "";
      this.$nextTick(() => {
        if (this.$refs.faceManagement) {
          this.$refs.faceManagement.validateField('urlWebFace');
        }
      });
    },
    handlePreviewFace() {
      if (this.facePreviewUrl) {
        this.facePreviewDialogUrl = this.facePreviewUrl;
      } else if (this.kidFaceManagement.urlWebFace && !this.checkCreateRecognition) {
        this.facePreviewDialogUrl = this.kidFaceManagement.urlWebFace;
      }
      this.facePreviewDialogVisible = true;
    },
    async beforeFaceUpload(file, listFile) {
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      if (!isJPG && !isPNG) {
        this.$message.error("Bạn phải chọn dạng ảnh");
        this.$refs.uploadFace.clearFiles();
        throw "file not valid";
      }
      if (file.raw.size > 200 * 1024) {
        const compressedFile = await this.compressImage(file, 200, 0.9);
        const newFile = new File([compressedFile], file.name, {type: file.raw.type});
        file.raw = newFile;
        console.log("size", file.raw.size);
      }
      this.showPictureInitial = false;
      this.showUploadFace = !this.showUploadFace;
      this.imageFaceUrl = file.raw;
      this.listFileFace = listFile;
    },
    handleRemoveFace() {
      this.$refs.uploadFace.clearFiles();
      setTimeout(() => {
        this.showPictureInitial = true;
        this.listFileFace = [];
        this.showUploadFace = true;
      }, 800);
      this.imageFaceUrl = null;
    },
    async getListDeviceRecognition() {
      await employeeDataService.getListDeviceRecognition().then((response) => {
        if (response.data.data.length > 0) {
          this.listIdDevice = response.data.data;
          this.searchUserRequest.idDevice = response.data.data[0].id;
          this.kidFaceManagement.idDevice = response.data.data[0].id;
          this.searchUserRequest.idUser = this.idEmployeeEdit;
        }
      })
    },
    async getUserRecognition() {
      await employeeDataService.getUserRecognition(this.searchUserRequest.idUser, this.searchUserRequest.idDevice, this.searchUserRequest.typeAccount).then((response) => {
        const curIdDevice = this.kidFaceManagement.idDevice || this.searchUserRequest.idDevice;
        const curIdDeviceList = (this.kidFaceManagement.idDeviceList && this.kidFaceManagement.idDeviceList.length > 0)
            ? this.kidFaceManagement.idDeviceList
            : this.idDeviceList;
        this.idDeviceList = curIdDeviceList || [];
        this.kidFaceManagement = {
          ...response.data.data,
          idDevice: curIdDevice,
          idDeviceList: curIdDeviceList || [],
        };
        if (this.kidFaceManagement.startTime !== null && this.kidFaceManagement.startTime !== undefined) {
          this.kidFaceManagement.startTime = this.kidFaceManagement.startTime.split("T")[0];
        }
        if (this.kidFaceManagement.endTime !== null && this.kidFaceManagement.endTime !== undefined) {
          this.kidFaceManagement.endTime = this.kidFaceManagement.endTime.split("T")[0];
        }
        this.cardList = [];
        this.cardListDataBase = [];
        this.numberCard = 0;
        if (this.kidFaceManagement.listCard !== null && this.kidFaceManagement.listCard !== undefined) {
          let cardListDB = this.kidFaceManagement.listCard;

          for (let i = 0; i < cardListDB.length; i++) {
            let card = {
              cardType: "normalCard",
              cardNo: cardListDB[i].cardNo,
              cardName: cardListDB[i].cardName,
              cardCode: cardListDB[i].cardCode,
              cardCodeShow: cardListDB[i].cardCode,
            };
            this.cardList.push(card);
            this.cardListDataBase.push(card);
          }
          this.numberCard = this.cardList.length;
        }
        this.listFinger = [];
        this.listFingerDB = [];
        this.numberFinger = 0;
        if (this.kidFaceManagement.listFingerprint !== null && this.kidFaceManagement.listFingerprint !== undefined) {
          let listFingerPrintDB = this.kidFaceManagement.listFingerprint;
          for (let i = 0; i < listFingerPrintDB.length; i++) {
            let fingerObject = {
              fingerNo: Number(listFingerPrintDB[i].fingerNo),
              fingerData: "",
              fingerName: listFingerPrintDB[i].fingerName,
            };
            this.listFinger.push(fingerObject);
            this.listFingerDB.push(fingerObject);
          }
          this.numberFinger = this.listFinger.length;
        }
        if (this.kidFaceManagement.name === null || this.kidFaceManagement.name === "" || !this.kidFaceManagement.name) {
          this.kidFaceManagement.name = this.formAllTabEmployee.updateEmployeeMainInfoRequest.fullName;
        }
        if (this.kidFaceManagement.id === null || this.kidFaceManagement.id === undefined) {
          this.checkCreateRecognition = true;
          this.titleButtonRecognition = "Tạo mới";
        } else {
          this.checkCreateRecognition = false;
          this.titleButtonRecognition = "Cập nhật";
        }
      });
    },
    convertVietnameseToUpperCaseNoAccent(text) {
      let str = text
      str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      str = str.replace(/đ/g, 'd').replace(/Đ/g, 'D')
      return str.toUpperCase()
    },

    handleClearUserRecognition() {
      if (this.$refs.uploadFace) {
        this.$refs.uploadFace.clearFiles();
      }
      if (this.$refs.faceManagement) {
        this.$refs.faceManagement.clearValidate();
      }
      this.kidFaceManagement.id = null
      this.kidFaceManagement.name = ""
      this.kidFaceManagement.startTime = ""
      this.kidFaceManagement.endTime = ""
      this.kidFaceManagement.urlWebFace = ""
      this.kidFaceManagement.idDevice = this.searchUserRequest.idDevice || null;
      this.kidFaceManagement.idDeviceList = [];
      this.imageFaceUrl = null;
      this.facePreviewUrl = "";
      this.listFileFace = [];
      this.checkCreateRecognition = true
      this.showUploadFace = true;
      this.cardList = []
      this.cardListDataBase = []
      this.listFinger = []
      this.listFingerDelete = []
      this.kidFaceManagement.listCard = []
      this.listCardDelete = []
      this.listFingerDB = []
      this.contentDevice = ""
      this.checkRecognition = false
      this.card = {}
      this.finger = {}
      this.listFingerUpdate = []
      this.listCardUpdate = []
      this.numberCard =  0
      this.numberFinger = 0
      this.cardCode = ""
      this.cardCodeShow = ""
      this.cardCodeEdit = ""
      this.idDeviceList =  []
    },
    handleStartDateChange(startDate) {
      if (!startDate) return;
      const start = new Date(startDate);
      const end = new Date(start);
      end.setFullYear(start.getFullYear() + 10); // Thêm 10 năm
      // Định dạng ngày thành chuỗi yyyy-MM-dd
      const formattedEnd = end.toISOString().split('T')[0];

      this.kidFaceManagement.endTime = formattedEnd;
      this.$nextTick(() => {
        if (this.$refs.faceManagement) {
          this.$refs.faceManagement.validateField('startTime');
          this.$refs.faceManagement.validateField('endTime');
        }
      });
    },
    handleCurrentDeviceChange(val) {
      this.searchUserRequest.idDevice = val;
      this.kidFaceManagement.idDevice = val;
      this.getUserRecognition();
      this.$nextTick(() => {
        if (this.$refs.faceManagement) {
          this.$refs.faceManagement.validateField('idDevice');
        }
      });
    },
    handleDeviceListChange(val) {
      this.idDeviceList = val;
      this.kidFaceManagement.idDeviceList = val;
      this.$nextTick(() => {
        if (this.$refs.faceManagement) {
          this.$refs.faceManagement.validateField('idDeviceList');
        }
      });
    },
    async submitFormFaceManagement(fromData) {
      this.$refs[fromData].validate(async (valid) => {
        if (valid) {
          const deviceId = this.kidFaceManagement.idDevice || this.searchUserRequest.idDevice;
          if (!deviceId || deviceId === 0) {
            NotifyMessage.leftCornerNotificationError("Thiết bị hiện tại không được để trống");
            return;
          }
          const deviceList = (this.kidFaceManagement.idDeviceList && this.kidFaceManagement.idDeviceList.length > 0)
              ? this.kidFaceManagement.idDeviceList
              : this.idDeviceList;
          if (!deviceList || deviceList.length === 0) {
            NotifyMessage.leftCornerNotificationError("Thiết bị nhận diện không được để trống");
            return;
          }
          if (this.checkPermission(['recognition-manager-face-employee']) && !this.hasFaceImage) {
            NotifyMessage.leftCornerNotificationError("Ảnh không được để trống");
            return;
          }
          if (!this.kidFaceManagement.startTime) {
            NotifyMessage.leftCornerNotificationError("Ngày bắt đầu không được để trống");
            return;
          }
          if (!this.kidFaceManagement.endTime) {
            NotifyMessage.leftCornerNotificationError("Ngày kết thúc không được để trống");
            return;
          }
          this.checkRecognition = true
          this.loadingButtonRecognition = true
          console.log(this.listFileFace)
          let formData = new FormData();
          formData.append("id", this.kidFaceManagement.id);
          formData.append("idUser", this.idEmployeeEdit);
          formData.append("name", this.kidFaceManagement.name);
          formData.append("typeAccount", "teacher");
          formData.append("startTime", this.kidFaceManagement.startTime + "T00:00:00");
          formData.append("endTime", this.kidFaceManagement.endTime + "T23:59:00");
          formData.append("idDevice", deviceId);
          formData.append("listCardDelete", this.listCardDelete);
          formData.append("listFingerDelete", this.listFingerDelete);
          if (this.cardList.length > 0) {
            const dbCardNos = new Set(this.cardListDataBase.map(card => card.cardNo));

            const newCardList = this.cardList.filter(card => !dbCardNos.has(card.cardNo));

            newCardList.forEach((item, i) => {
              formData.append(`listCardNew[${i}].cardType`, item.cardType);
              formData.append(`listCardNew[${i}].cardNo`, item.cardNo);
              formData.append(`listCardNew[${i}].cardName`, item.cardName);
              formData.append(`listCardNew[${i}].cardCode`, item.cardCode);
            });
          }
          if (this.listCardUpdate.length > 0) {
            this.listCardUpdate.forEach((item, i) => {
              formData.append(`listCardUpdate[${i}].cardType`, item.cardType);
              formData.append(`listCardUpdate[${i}].cardNo`, item.cardNo);
              formData.append(`listCardUpdate[${i}].cardName`, item.cardName);
              formData.append(`listCardUpdate[${i}].cardCode`, item.cardCode);
            });
          }
          if (this.listFinger.length > 0) {
            const validListFinger = this.listFinger.filter(item => item.fingerData !== "");
            validListFinger.forEach((item, i) => {
              formData.append(`listFingerNew[${i}].fingerNo`, item.fingerNo);
              formData.append(`listFingerNew[${i}].fingerData`, item.fingerData);
              formData.append(`listFingerNew[${i}].fingerName`, item.fingerName);
            });
          }
          if (this.listFingerUpdate.length > 0) {
            this.listFingerUpdate.forEach((item, i) => {
              formData.append(`listFingerUpdate[${i}].fingerNo`, item.fingerNo);
              formData.append(`listFingerUpdate[${i}].fingerData`, item.fingerData);
              formData.append(`listFingerUpdate[${i}].fingerName`, item.fingerName);
            });
          }
          formData.append("idDeviceList", deviceList);
          if (this.listFileFace.length > 0) {
            formData.append("image", this.listFileFace[0].raw);
          }
          let isSuccess = false;
          try {
            if (this.checkCreateRecognition === true) {
              const response = await employeeDataService.addUserToManyDevice(formData);
              if (response.data.status === 200 && response.data.data === true) {
                isSuccess = true;
                NotifyMessage.leftCornerNotificationSuccess("Thêm mới thành công");
              } else {
                NotifyMessage.leftCornerNotificationError((response.data && response.data.message) || "Thêm mới thất bại");
              }
            } else {
              const response = await employeeDataService.updateUserToManyDevice(formData);
              if (response.data.status === 200 && response.data.data === true) {
                isSuccess = true;
                NotifyMessage.leftCornerNotificationSuccess("Cập nhật thành công");
              } else {
                NotifyMessage.leftCornerNotificationError((response.data && response.data.message) || "Cập nhật thất bại");
              }
            }
          } catch (e) {
            NotifyMessage.leftCornerNotificationError("Lỗi cập nhật");
            console.log(e);
          } finally {
            this.loadingButtonRecognition = false;
            this.checkRecognition = false;
          }

          if (isSuccess) {
            this.listFileFace = [];
            this.facePreviewUrl = "";
            if (this.$refs.uploadFace) {
              this.$refs.uploadFace.clearFiles();
            }
            this.listCardDelete = [];
            this.listFingerDelete = [];
            this.listCardUpdate = [];
            this.listFingerUpdate = [];
            this.card = {};
            this.finger = {};
            this.cardCode = "";
            this.cardCodeShow = "";
            this.cardCodeEdit = "";
            await this.getUserRecognition();
            this.$nextTick(() => {
              if (this.$refs[fromData]) {
                this.$refs[fromData].clearValidate();
              }
            });
          }
        } else {
          console.log("error validate data!");
          NotifyMessage.leftCornerNotificationError("Vui lòng nhập đầy đủ các thông tin bắt buộc");
          return false;
        }
      });
    },
    compressImage(file, maxSizeKB = 200, quality = 0.9) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = (event) => {
          const img = new Image();
          img.src = event.target.result;
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            let width = img.width;
            let height = img.height;
            const maxDim = 1024;
            if (width > maxDim || height > maxDim) {
              if (width > height) {
                height *= maxDim / width;
                width = maxDim;
              } else {
                width *= maxDim / height;
                height = maxDim;
              }
            }

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            function attemptCompression(q) {
              canvas.toBlob((blob) => {
                if (!blob) {
                  reject(new Error("Không thể tạo blob"));
                  return;
                }
                if (blob.size / 1024 <= maxSizeKB || q < 0.3) {
                  resolve(blob);
                } else {
                  attemptCompression(q - 0.1);
                }
              }, "image/jpeg", q);
            }

            attemptCompression(quality);
          };
        };
        reader.onerror = (error) => {
          console.error("Lỗi đọc file:", error);
          reject(error);
        };
      });
    },

    deleteDataRecognition() {
      this.$confirm(
          "Bạn có chắc chắn muốn xóa dữ liệu đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          }
      ).then(() => {
        employeeDataService.deleteDataRecognition(this.kidFaceManagement.id).then((response) => {
          if (response.data.status === 200) {
            if (response.data.data === true) {
              this.numberCard = 0
              this.numberFinger = 0
              this.handleClearUserRecognition()
              NotifyMessage.leftCornerNotificationSuccess("Xóa dữ liệu thành công!")
            } else {
              NotifyMessage.leftCornerNotificationError("Xóa dữ liệu thất bại!")
            }
          } else {
            NotifyMessage.leftCornerNotificationError("Xóa dữ liệu thất bại!")
          }
        }).catch(error => {
          NotifyMessage.leftCornerNotificationError("Xóa dữ liệu thất bại!")
          console.log(error)
        })
      })
    },
    handledOpenAddFingerDialog() {
      if (this.numberFinger >= this.kidFaceManagement.fingerNumber){
        NotifyMessage.leftCornerNotificationError("Quá số lượng vân tay được thêm!")
        return
      }
      this.dialogVisibleFinger = true
    },
    handleCloseFinger(){
      this.dialogVisibleFinger = false
      this.fingerName = "Nhân viên"
    },
    async getInformationFinger() {
      let finger = 1
      if (this.listFinger.length > 0) {
        let listIndexFinger = []
        const listNumber = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        for (let i = 0; i < this.listFinger.length; i++) {
          listIndexFinger.push(this.listFinger[i].fingerNo)
        }
        let minInList2 = Math.min(...listIndexFinger)
        finger = listNumber
            .filter(n => !listIndexFinger.includes(n) && n > minInList2)
            .sort((a, b) => a - b)[0];
      }
      this.contentDevice = "Đưa ngón tay vào khu vực lấy dấu vân tay!"
      this.showWarning = true
      this.loadingRecognition = true
      await employeeDataService.getInformationFinger(this.searchUserRequest.idDevice, finger).then(response => {
        if (response.data.status === 200) {
          this.showWarning = false
          this.loadingRecognition = false
          if (response.data.data.fingerData !== null) {
            let fingerObject = {
              fingerNo: Number(response.data.data.fingerNo),
              fingerData: response.data.data.fingerData,
              fingerName: this.fingerName,
            }
            this.listFinger.push(fingerObject)
            this.numberFinger = this.listFinger.length
          }
        }
      }).catch(error => {
        console.log(error)
      })
      this.handleCloseFinger()
    },
    handledOpenAddCardDialog() {
      if (this.numberCard >= this.kidFaceManagement.cardNumber){
        NotifyMessage.leftCornerNotificationError("Quá số lượng thẻ được thêm!")
        return
      }
      this.dialogVisibleCard = true
    },
    handleCloseCard(){
      this.dialogVisibleCard = false
      this.cardName = "Nhân viên"
    },
    async getInformationNumberCard() {
      this.contentDevice = "Đưa thẻ vào khu vực đọc thẻ!"
      this.showWarning = true
      this.loadingRecognition = true
      await employeeDataService.getInformationNumberCard(this.searchUserRequest.idDevice).then((response) => {
        if (response.data.status === 200) {
          this.showWarning = false
          this.loadingRecognition = false

          if (response.data.data !== null) {
            let cardRequest = {
              cardType: "normalCard",
              cardNo: response.data.data,
              cardName: this.cardName,
              cardCode: this.cardCode,
              cardCodeShow: this.kidFaceManagement.idSchool + " - " + this.cardCode,
            }
            let checkExit = false;
            for (let i = 0; i < this.cardList.length; i++) {
              if (cardRequest.cardNo === this.cardList[i].cardNo) {
                NotifyMessage.leftCornerNotificationError("Thẻ đã tồn tại!")
                checkExit = true;
                break
              }
            }
            if (checkExit === false) {
              this.cardList.push(cardRequest);
              this.numberCard = this.cardList.length
            }
          }
        }
      }).catch(error => {
        console.log(error)
      })
      this.handleCloseCard()
    },

    handleDeleteCard(index) {
      const card = this.cardList[index];
      this.cardList.splice(index, 1);
      let indexCard = -1;
      for (let i = 0; i < this.cardListDataBase.length; i++) {
        if (card.cardNo === this.cardListDataBase[i].cardNo) {
          this.listCardDelete.push(this.cardListDataBase[i].cardNo.toString())
          indexCard = i
          break
        }
      }
      if (indexCard !== -1) {
        this.cardListDataBase.splice(indexCard, 1);
      }
    },

    handleDeleteFinger(fp) {
      let index = -1
      this.listFinger = this.listFinger.filter(item => item.fingerNo !== fp.fingerNo);
      for (let i = 0; i < this.listFingerDB.length; i++) {
        if (fp.fingerNo === this.listFingerDB[i].fingerNo) {
          this.listFingerDelete.push(Number(fp.fingerNo))
          index = i
          break
        }
      }
      if (index !== -1) {
        this.cardListDataBase.splice(index, 1);
      }
    },

    handleEditCard(index) {
      const card = this.cardList[index];
      this.cardNameEdit = card.cardName
      if (card.cardCodeShow !== null && card.cardCodeShow !== "") {
        this.cardCodeEdit = card.cardCodeShow.split("-")[1].trim();
      }
      this.card = card
      this.dialogVisibleEditCard = true
    },
    handleCloseEditCard(){
      this.dialogVisibleEditCard = false
      this.cardNameEdit = ""
      this.cardCode = ""
    },
    saveInformationNumberCard(card) {
      for (let i = 0; i < this.cardList.length; i++) {
        if (card.cardNo === this.cardList[i].cardNo) {
          this.cardList[i].cardName = this.cardNameEdit
          this.cardList[i].cardCode = this.cardCodeEdit
          this.cardList[i].cardCodeShow = this.kidFaceManagement.idSchool + " - " + this.cardCodeEdit
        }
      }
      let checkUpdate = false
      for (let i = 0; i < this.cardListDataBase.length; i++) {
        if (card.cardNo === this.cardListDataBase[i].cardNo){
          checkUpdate = true
          break
        }
      }
      if (checkUpdate !== false) {
        if (this.listCardUpdate.length > 0) {
          let exit = false
          for (let i = 0; i < this.listCardUpdate.length; i++) {
            if (card.cardNo === this.listCardUpdate[i].cardNo){
              exit = true
              this.listCardUpdate[i].cardName = this.cardNameEdit
              this.listCardUpdate[i].cardCode = this.cardCodeEdit
              this.listCardUpdate[i].cardCodeShow = this.kidFaceManagement.idSchool + " - " + this.cardCodeEdit
              break
            }
          }
          if (exit === false) {
            this.listCardUpdate.push(card);
          }
        } else {
          this.listCardUpdate.push(card);
        }
      }
      this.handleCloseEditCard()
    },
    handleEditFinger(finger) {
      this.finger = finger
      this.fingerNameEdit = finger.fingerName
      this.dialogVisibleEditFinger = true
    },
    handleCloseEditFinger(){
      this.dialogVisibleEditFinger = false
      this.fingerNameEdit = ""
    },
    saveInformationEditFinger(finger) {
      for (let i = 0; i < this.listFinger.length; i++) {
        if (finger.fingerNo === this.listFinger[i].fingerNo) {
          this.listFinger[i].fingerName = this.fingerNameEdit
        }
      }
      let checkUpdate = false
      for (let i = 0; i < this.listFingerDB.length; i++) {
        if (finger.fingerNo === this.listFingerDB[i].fingerNo){
          checkUpdate = true
          break
        }
      }
      if (checkUpdate !== false) {
        if (this.listFingerUpdate.length > 0) {
          let exit = false
          for (let i = 0; i < this.listFingerUpdate.length; i++) {
            if (finger.fingerNo === this.listFingerUpdate[i].fingerNo){
              exit = true
              this.listFingerUpdate[i].fingerName = this.fingerNameEdit
              break
            }
          }
          if (exit === false) {
            this.listFingerUpdate.push(finger);
          }
        } else {
          this.listFingerUpdate.push(finger);
        }
      }
      this.handleCloseEditFinger()
    },

    async innitDataRecognition() {
      await this.getListDeviceRecognition();
      await this.getUserRecognition();
    }


  },
};
</script>
<style>
.hideUpload > div {
  display: none;
}
</style>
<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";

// /deep/.el-input__inner,
// /deep/.el-textarea__inner {
//   border: none;
//   border-radius: 0;
//   resize: none;
//   padding-left: 0;
//   padding-right: 0;
//   border-bottom: 1px solid #d9d9d9;
// }
/deep/ .update-employee-dialog {
  border-radius: 20px;
  overflow: hidden;
}

/deep/ .update-employee-dialog .el-dialog__header {
  padding: 18px 22px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

/deep/ .update-employee-dialog .el-dialog__body {
  padding: 18px 22px 8px;
}

/deep/ .update-employee-dialog .el-dialog__footer {
  padding: 10px 22px 20px;
}

/deep/ .update-employee-dialog .el-dialog__title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
}

.update-employee-content {
  padding: 4px 0 6px;
}

.employee-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px;
}

/deep/ .update-employee-tabs > .el-tabs__header {
  margin-bottom: 18px;
}

/deep/ .el-form-item__label {
  font-family: Inter, Arial, Helvetica, sans-serif;
  color: #475569;
  font-weight: 600;
}

/deep/ .el-form-item {
  margin-bottom: 16px;
}

/deep/ .el-input__inner {
  border-radius: 10px;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .upload-demo {
  text-align: center;

  .el-upload {
    width: 100%;
  }
}

/deep/ .el-avatar {
  display: inline;

  img {
    border-radius: 5px;
    width: 100%;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  text-align: left;
  color: #d13b93;
  font-weight: bold;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.update-employee-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.ai-management-form {
  padding: 4px 0;
}

.ai-layout {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ai-panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px 20px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.03);
}

.ai-panel-intro {
  background: linear-gradient(135deg, #f8fbff 0%, #f1f5ff 100%);
  border-color: #dbeafe;
  padding: 14px 20px;
}

.ai-panel-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.ai-panel-subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #64748b;
}

.ai-panel-inner-title {
  font-size: 14px;
  font-weight: 700;
  color: #334155;
  margin-bottom: 16px;
  border-left: 4px solid #3b82f6;
  padding-left: 8px;

  &.required::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}

.ai-face-form-item {
  margin-bottom: 0;
  width: 100%;

  ::v-deep .el-form-item__content {
    line-height: normal;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ::v-deep .el-form-item__error {
    position: static;
    margin-top: 8px;
    text-align: center;
    font-weight: 500;
  }
}

.ai-upper-layout {
  display: flex;
  align-items: stretch;
}

.ai-avatar-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ai-avatar-scanner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
}

.ai-avatar-scanner-view {
  position: relative;
  width: 160px;
  height: 160px;
  padding: 4px;
  background: #ffffff;
  border-radius: 14px;
}

.scanner-corner {
  position: absolute;
  width: 14px;
  height: 14px;
  border: 3px solid #3b82f6;
  z-index: 10;
  pointer-events: none;
  
  &.top-left {
    top: -2px;
    left: -2px;
    border-right: none;
    border-bottom: none;
    border-top-left-radius: 10px;
  }
  &.top-right {
    top: -2px;
    right: -2px;
    border-left: none;
    border-bottom: none;
    border-top-right-radius: 10px;
  }
  &.bottom-left {
    bottom: -2px;
    left: -2px;
    border-right: none;
    border-top: none;
    border-bottom-left-radius: 10px;
  }
  &.bottom-right {
    bottom: -2px;
    right: -2px;
    border-left: none;
    border-top: none;
    border-bottom-right-radius: 10px;
  }
}

.scanner-line {
  position: absolute;
  left: 4px;
  right: 4px;
  width: calc(100% - 8px);
  height: 2px;
  background: linear-gradient(90deg, rgba(59, 130, 246, 0) 0%, #3b82f6 50%, rgba(59, 130, 246, 0) 100%);
  z-index: 11;
  pointer-events: none;
  animation: scan 2.5s linear infinite;
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.8);
}

@keyframes scan {
  0% { top: 4px; }
  50% { top: calc(100% - 6px); }
  100% { top: 4px; }
}

.ai-avatar-box {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ai-avatar-preview {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

.ai-upload-face-hidden {
  display: none;
}

.ai-avatar-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #94a3b8;
  font-size: 13px;
  
  i {
    font-size: 28px;
    color: #cbd5e1;
  }
}

.ai-face-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
}

/deep/ .face-preview-dialog {
  border-radius: 16px;
  overflow: hidden;
  
  .el-dialog__header {
    padding: 14px 20px;
    border-bottom: 1px solid #f1f5f9;
  }
  
  .el-dialog__body {
    padding: 16px;
    display: flex;
    justify-content: center;
  }
}

.face-preview-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  
  img {
    max-width: 100%;
    max-height: 60vh;
    border-radius: 10px;
    object-fit: contain;
  }
}

.ai-avatar-note {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  line-height: 1.4;
  color: #1d4ed8;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  padding: 8px 10px;
  
  i {
    margin-top: 2px;
    font-size: 14px;
  }
}

.ai-section {
  margin-top: 0;
}

.ai-form-panel {
  height: 100%;
}

.ai-control {
  width: 100%;
}

.ai-counter-title {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ai-counter-label {
  color: #0f172a;
  font-weight: 700;
  font-size: 14px;
}

.ai-counter-value {
  color: #3b82f6;
  font-weight: 700;
  font-size: 14px;
  background: #eff6ff;
  padding: 2px 8px;
  border-radius: 9999px;
}

.ai-item-col {
  margin-bottom: 20px;
}

.ai-card-item {
  border-radius: 16px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: #ffffff;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.12);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100px;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(59, 130, 246, 0.22);
    
    .card-actions-overlay {
      opacity: 1;
    }
  }
}

.ai-finger-item {
  border-radius: 16px;
  background: linear-gradient(135deg, #0d9488 0%, #14b8a6 100%);
  color: #ffffff;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(13, 148, 136, 0.12);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100px;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(13, 148, 136, 0.22);
    
    .card-actions-overlay {
      opacity: 1;
    }
  }
}

.ai-card-content {
  padding: 14px 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ai-card-text {
  color: #ffffff;
  
  strong {
    font-size: 14px;
    font-weight: 600;
    display: block;
    margin-bottom: 4px;
    color: #ffffff;
  }
  
  div {
    font-size: 11px;
    opacity: 0.85;
    font-family: monospace, Courier, sans-serif;
  }
}

.ai-card-icon {
  position: absolute;
  bottom: 8px;
  right: 12px;
  width: 48px;
  height: auto;
  opacity: 0.15;
  pointer-events: none;
}

.card-actions-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  opacity: 0;
  transition: opacity 0.25s ease;
  border-radius: 16px;
  z-index: 10;
}

.action-btn {
  font-size: 20px;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
  color: #e2e8f0;
  
  &:hover {
    transform: scale(1.2);
  }
  
  &.edit:hover {
    color: #60a5fa;
  }
  
  &.delete:hover {
    color: #ef4444;
  }
}

.ai-add-item {
  height: 100px;
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background: #f8fafc;
  color: #64748b;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  
  i {
    font-size: 20px;
  }
  
  &:hover {
    border-color: #3b82f6;
    color: #3b82f6;
    background: #eff6ff;
  }
}

.ai-finger-section {
  margin-top: 16px;
}

.ai-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
}

.ai-btn-delete {
  margin-right: 0 !important;
  min-width: 170px;
  border-radius: 12px;
  background: transparent !important;
  border: 1px solid #ef4444 !important;
  color: #ef4444 !important;
  transition: all 0.3s ease;
  font-weight: 600;
  
  &:hover {
    background: #ef4444 !important;
    color: #ffffff !important;
  }
}

.ai-btn-submit {
  margin-right: 0 !important;
  min-width: 170px;
  border-radius: 12px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);
  }
  
  &:disabled {
    background: #cbd5e1 !important;
    box-shadow: none;
    cursor: not-allowed;
  }
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

.table-icon-1 {
  width: 30%;
  margin-left: 15%;
  display: inline-block;
}

.table-icon-2 {
  width: 35%;
  margin-right: 15%;
  float: right;
}

// /deep/.el-tabs__item {
//   color: white;
// }
// /deep/.el-tabs__item.is-active {
//   color: white;
//   background: #67c23a;
// }
// /deep/.el-tabs__nav {
//   background: #a0a19ce0;
// }
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.container_upload {
  display: flex;
  flex-direction: column;

  & + & {
    margin-top: 34px;
  }

  .title_upload_image {
    margin-bottom: 10px;
  }
}

.container_upload_image {
  margin-top: 12px;
}

/deep/ .qr-uploader,
/deep/ .avatar-uploader {
  position: relative;
  width: 206px;

  .el-upload--picture-card {
    position: absolute;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    top: -27px;
    right: 50px;
    background-color: transparent;
  }

  .btn_upload {
    background-color: #fff;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 1px solid #ccc;

    &:hover {
      background-color: #ccc;
      color: #fff;
      transition: 0.5s ease-in-out;
    }
  }
}
.upload-card-placeholder {
  border: 1px dashed #409EFF;
  height: 60px;
  width: 240px;
  text-align: center;
  padding-top: 40px;
  color: #409EFF;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
}

.card-item {
  position: relative;
  height: 80px;
  width: 230px;
  padding: 10px;
}

.card-content {
  position: relative;
  height: 100%;
  bottom: 20px;
  right: 20px;
}

.card-text {
  font-size: 16px;
  z-index: 1;
}

.card-icon {
  position: absolute;
  top: 40px;
  left: 160px;
  width: 80px;
  height: 50px;
  opacity: 0.4; /* tuỳ chỉnh nếu cần */
}

.delete-icon {
  position: absolute;
  bottom: 20px;
  left: 210px;
  font-size: 20px;
  color: #f56c6c;
  cursor: pointer;
  z-index: 2;
}
.edit-icon {
  position: absolute;
  bottom: 20px;
  left: 180px;
  font-size: 20px;
  color: #3091f5;
  cursor: pointer;
  z-index: 2;
}

.delete-icon-finger {
  position: absolute;
  left: 210px;
  font-size: 20px;
  color: #f56c6c;
  cursor: pointer;
  z-index: 2;
}
.edit-icon-finger {
  position: absolute;
  left: 180px;
  font-size: 20px;
  color: #3091f5;
  cursor: pointer;
  z-index: 2;
}
/deep/ .el-upload--picture-card {
  margin-left: 10px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
}

.custom_button {
  display: flex;
  justify-content: right;
  margin-top: 30px;
}

/deep/ .btn-cancel,
/deep/ .btn-save {
  min-width: 110px;
  border-radius: 10px;
}

/* Redesigned Information Tab Style rules */
.common-info-tab {
  & > .el-row {
    display: flex;
    align-items: stretch;
  }

  /deep/ .el-form-item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 16px;
    
    .el-form-item__label {
      width: 100% !important;
      text-align: left;
      float: none;
      line-height: 20px;
      padding: 0 0 6px 0;
      font-size: 13px;
      font-weight: 600;
      color: #475569;
    }
    
    .el-form-item__content {
      margin-left: 0 !important;
      line-height: normal;
    }
  }
}

.profile-sidebar-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  box-sizing: border-box;
}

.profile-avatar-wrap {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  background: #f8fafc;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  
  .profile-avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-trigger-area {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #64748b;
    font-size: 12px;
    font-weight: 500;
    gap: 4px;
    transition: all 0.2s ease;

    i {
      font-size: 20px;
      font-weight: bold;
    }

    &:hover {
      background: #f1f5f9;
      color: #3b82f6;
    }
  }

  .avatar-actions-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(15, 23, 42, 0.65);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    opacity: 0;
    transition: opacity 0.25s ease;
    z-index: 10;
  }

  &:hover .avatar-actions-overlay {
    opacity: 1;
  }

  .avatar-action-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    outline: none;
    background: #ffffff;
    color: #0f172a;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      transform: scale(1.1);
    }

    &.edit-btn:hover {
      background: #3b82f6;
      color: #ffffff;
    }

    &.delete-btn:hover {
      background: #ef4444;
      color: #ffffff;
    }
  }
}

.qr-bank-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qr-container-wrap {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
  
  .qr-bank-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 6px;
    box-sizing: border-box;
  }
}

.qr-trigger-area {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  gap: 4px;
  transition: all 0.2s ease;

  i {
    font-size: 20px;
    font-weight: bold;
  }

  &:hover {
    background: #f1f5f9;
    color: #10b981;
  }
}

.qr-actions-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  opacity: 0;
  transition: opacity 0.25s ease;
  z-index: 10;
}

.qr-container-wrap:hover .qr-actions-overlay {
  opacity: 1;
}

.profile-code-section {
  text-align: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px 12px;
}

.profile-code-label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: block;
}

.profile-code-value {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-top: 2px;
  font-family: monospace;
}

.profile-status-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-divider {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.status-radio-group {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
  
  /deep/ .el-radio-button {
    width: 100%;
    margin: 0;
    
    .el-radio-button__inner {
      width: 100%;
      border-radius: 10px !important;
      border: 1px solid #e2e8f0;
      box-shadow: none !important;
      padding: 10px 15px;
      font-size: 13px;
      font-weight: 500;
      transition: all 0.2s ease;
      color: #64748b;
    }
    
    &.is-active .el-radio-button__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
      color: #ffffff;
    }
  }
}

.status-date-wrap {
  background: #fffbeb;
  border: 1px solid #fef3c7;
  border-radius: 12px;
  padding: 12px;
  margin-top: 4px;
}

.info-section-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  margin-bottom: 20px;
  height: 100%;
  box-sizing: border-box;
}

.gender-radio-group {
  width: 100%;
  display: flex;
  
  /deep/ .el-radio-button {
    flex: 1;
    
    .el-radio-button__inner {
      width: 100%;
      border-radius: 10px !important;
      padding: 10px 0;
      text-align: center;
      border: 1px solid #e2e8f0;
      color: #64748b;
      font-weight: 500;
    }
    
    &.is-active .el-radio-button__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
      color: #ffffff;
    }
  }
}

.read-only-input {
  /deep/ .el-input__inner {
    background-color: #f8fafc !important;
    border-color: #e2e8f0 !important;
    color: #475569 !important;
    font-weight: 600;
  }
}
</style>
